import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { propArrayShape, propBool, propId, propShape, } from '@/helpers/custom-prop-types';
import InformationIcon from '../../../../../../Icon/Svg/InformationIcon';
import ViewRequestOrderItem from './ViewRequestOrderItem';
const ViewRequestOrders = (props) => {
    const { id, isAdmin, isCallEnd, isClientApproveViewRequest, isMemberAdmin, useCase, viewRequestOrders, } = props;
    const dispatch = useDispatch();
    const isEnabled = useMemo(() => {
        if (isCallEnd) {
            return false;
        }
        if (isAdmin) {
            return true;
        }
        if (!isClientApproveViewRequest) {
            return false;
        }
        return isMemberAdmin;
    }, [isCallEnd, isMemberAdmin, isClientApproveViewRequest, isAdmin]);
    const { onClickApprove, onClickDisApprove } = useCase.useOnClick(id, dispatch);
    return (_jsxs("div", Object.assign({ className: 'rfp-view-request-orders' }, { children: [_jsx("h4", Object.assign({ className: 'title_label' }, { children: "\u6848\u4EF6\u5185\u5BB9\u306E\u958B\u793A\u4F9D\u983C\u3092\u3057\u3066\u3044\u308B\u30C1\u30FC\u30E0" })), _jsxs("div", Object.assign({ className: 'message_box' }, { children: [_jsx(InformationIcon, {}), _jsx("p", Object.assign({ className: 'message_text' }, { children: isClientApproveViewRequest
                            ? '案件内容の開示を許可してください（案件責任者のみご対応可能）'
                            : 'Proffitが開示依頼の対応いたしますので、お手すきの際にコンサルのプロフィールなどをご確認ください' }))] })), _jsx("div", Object.assign({ className: 'order_items' }, { children: viewRequestOrders.map((viewRequestOrder) => (_jsx(ViewRequestOrderItem, { isEnabled: isEnabled, onClickApprove: onClickApprove, onClickDisApprove: onClickDisApprove, viewRequestOrder: viewRequestOrder }, viewRequestOrder.id))) }))] })));
};
ViewRequestOrders.propTypes = {
    id: propId().isRequired,
    isAdmin: propBool().isRequired,
    isCallEnd: propBool().isRequired,
    isClientApproveViewRequest: propBool().isRequired,
    isMemberAdmin: propBool().isRequired,
    useCase: propShape().isRequired,
    viewRequestOrders: propArrayShape().isRequired,
};
export default ViewRequestOrders;
